import * as React from "react";

function SvgSearch(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M23.46 20.3l-5.74-5.74a9.29 9.29 0 001.36-4.87A9.9 9.9 0 009.4 0 9.4 9.4 0 000 9.4a9.9 9.9 0 009.69 9.68 9.28 9.28 0 004.73-1.28l5.77 5.78a1.45 1.45 0 002 0l1.44-1.44c.6-.56.37-1.27-.17-1.84zM2.89 9.4A6.5 6.5 0 019.4 2.89a7 7 0 016.79 6.8 6.5 6.5 0 01-6.5 6.5 7 7 0 01-6.8-6.79z" />
    </svg>
  );
}

const MemoSvgSearch = React.memo(SvgSearch);
export default MemoSvgSearch;
